import { Badge, Card, Col, Container, Row } from "react-bootstrap";
import { QrCode } from "react-bootstrap-icons";
import { useLoaderData, useNavigate } from "react-router-dom";
import { PageTitle } from "./Controls/PageTitle";
import { facilityImg } from "./Data/Common";
import { ServerTransferConnectSubListEntry, SubscriptionApi } from "./shared/api/axios-client";
import { useAtomValue } from "jotai";
import { authAtom } from "./Data/Atoms";
import { showSubscriptionStatus } from "./Data/Subscription";
import QrCodeModal from "./Controls/QRCodeModal";
import { useState } from "react";
import { createApiService } from "./shared/apiConfig";
import { InfoBox } from "./Controls/InfoBox";

const subscriptionApi = createApiService(SubscriptionApi)

export function UserAccessCodePage() {
    const nav = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const auth = useAtomValue(authAtom);
    const [qrCode, setQrCode] = useState('')
    const subs = useLoaderData() as ServerTransferConnectSubListEntry[];
    const callQrCode = (sub: ServerTransferConnectSubListEntry)=>{
        subscriptionApi.getParkerAccessCode({
            parkerId: auth.account?.parkerId!,
            subscriptionId: sub.subscriptionId!
        }).then((accessCode)=>{
            const response = accessCode.data as any
            setQrCode(response.metaFlashRFIDNumber)
            setShowModal(true)
        }).catch(()=>{

        })
    }


    return <Container fluid>
        <Row>
            <Col>
                <PageTitle>
                    Access Passes
                </PageTitle>
                <InfoBox>
                    Access passes are QR Codes that can be scanned to access a facility.
                </InfoBox>
                {subs.length === 0 && <>
                    You don't have any access passes
                </>}
                {subs.map(sub => {
                    const facility = sub.facility;
                    const quantity = sub.quantity;
                    const price = sub.price;
                    const notMine = sub.parkerId != auth.account!.parkerId;
                    const spots = sub.quantity;

                    return <Card key={sub.subscriptionId} className="my-2" style={{ cursor: "pointer" }}
                        onClick={() => callQrCode(sub)}>
                        <Card.Header className="text-start d-flex align-items-center gap-1">
                            {notMine && <Badge className="bg-primary">Guest</Badge>}
                            <Badge>{showSubscriptionStatus(sub.status!, "")}</Badge> {sub.plan?.name}
                        </Card.Header>
                        <Card.Body className="purchase-layout gap-2">
                            <div className="grid-area-a">
                                <img className="facility-result-pic"
                                    src={facilityImg(facility?.listImageId!)}
                                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
                            </div>
                            <div className="grid-area-b">
                                <div className="fw-bold">
                                    {sub.facility?.name}
                                </div>
                            </div>
                            <div className="grid-area-c position-relative" style={{ justifySelf: "end" }}>

                                
                            </div>
                            <div className="grid-area-d text-end d-flex gap-2">
                                <button
                                    type="button"
                                    className="rounded-4 border-primary border-2 status-btn text-black d-flex align-items-center justify-content-center btn btn-body-secondary"
                                >
                                    <QrCode className="me-2"/> Get QR Code 
                                </button>
                            </div>
                        </Card.Body>
                    </Card>;
                })}
            </Col>
        </Row>
        <QrCodeModal
            show={showModal}
            onHide={() => setShowModal(false)}
            value={qrCode}
            height={256}
        />
    </Container>;

}